import angular from 'angular'
import { EntityStore } from './entity-store'

export class UsersStore extends EntityStore<'users'> {
  constructor() {
    super({
      entityStoreName: 'users',
      syncDeleted: true,
    })
  }

  public get(id: string) {
    return super.get(id, true)
  }
}

export const usersStore: UsersStore = new UsersStore()

/**
 * Responsible for persisting storage of users from the /api/2.0/user or /api/2.0/users API end points into
 * IndexedDB.
 *
 * @module usersStore
 */
angular.module('webregister.factories').factory('usersStore', () => usersStore)
